import { render, staticRenderFns } from "./NoFiles.vue?vue&type=template&id=bf623d84"
import script from "./NoFiles.vue?vue&type=script&lang=js"
export * from "./NoFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports